/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Auth } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * LoginService - axios parameter creator
 * @export
 */
export const LoginServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * wechselt den User anhand des Payloads, Ausführung durch Admin, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
         * @summary Login change
         * @param {Auth} auth Authentifizierung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changelogin: async (auth: Auth, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'auth' is not null or undefined
            assertParamExists('changelogin', 'auth', auth)
            const localVarPath = `/api/authentication/changelogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auth, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Überprüft anhand des Payloads ob Username / Password übereinstimmen, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
         * @summary Login
         * @param {Auth} auth Authentifizierung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (auth: Auth, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'auth' is not null or undefined
            assertParamExists('login', 'auth', auth)
            const localVarPath = `/api/authentication/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auth, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * meldet den Benutzer ab
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualisiert den Access Token mit einem gültigen Refresh Token
         * @summary Token Update
         * @param {Auth} [auth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens: async (auth?: Auth, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auth, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginService - functional programming interface
 * @export
 */
export const LoginServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginServiceAxiosParamCreator(configuration)
    return {
        /**
         * wechselt den User anhand des Payloads, Ausführung durch Admin, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
         * @summary Login change
         * @param {Auth} auth Authentifizierung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changelogin(auth: Auth, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changelogin(auth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Überprüft anhand des Payloads ob Username / Password übereinstimmen, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
         * @summary Login
         * @param {Auth} auth Authentifizierung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(auth: Auth, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(auth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * meldet den Benutzer ab
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aktualisiert den Access Token mit einem gültigen Refresh Token
         * @summary Token Update
         * @param {Auth} [auth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokens(auth?: Auth, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokens(auth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginService - factory interface
 * @export
 */
export const LoginServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginServiceFp(configuration)
    return {
        /**
         * wechselt den User anhand des Payloads, Ausführung durch Admin, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
         * @summary Login change
         * @param {Auth} auth Authentifizierung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changelogin(auth: Auth, options?: any): AxiosPromise<Auth> {
            return localVarFp.changelogin(auth, options).then((request) => request(axios, basePath));
        },
        /**
         * Überprüft anhand des Payloads ob Username / Password übereinstimmen, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
         * @summary Login
         * @param {Auth} auth Authentifizierung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(auth: Auth, options?: any): AxiosPromise<Auth> {
            return localVarFp.login(auth, options).then((request) => request(axios, basePath));
        },
        /**
         * meldet den Benutzer ab
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<Auth> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualisiert den Access Token mit einem gültigen Refresh Token
         * @summary Token Update
         * @param {Auth} [auth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(auth?: Auth, options?: any): AxiosPromise<Auth> {
            return localVarFp.refreshTokens(auth, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginService - interface
 * @export
 * @interface LoginService
 */
export interface LoginServiceInterface {
    /**
     * wechselt den User anhand des Payloads, Ausführung durch Admin, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
     * @summary Login change
     * @param {Auth} auth Authentifizierung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginServiceInterface
     */
    changelogin(auth: Auth, options?: any): AxiosPromise<Auth>;

    /**
     * Überprüft anhand des Payloads ob Username / Password übereinstimmen, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
     * @summary Login
     * @param {Auth} auth Authentifizierung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginServiceInterface
     */
    login(auth: Auth, options?: any): AxiosPromise<Auth>;

    /**
     * meldet den Benutzer ab
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginServiceInterface
     */
    logout(options?: any): AxiosPromise<Auth>;

    /**
     * Aktualisiert den Access Token mit einem gültigen Refresh Token
     * @summary Token Update
     * @param {Auth} [auth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginServiceInterface
     */
    refreshTokens(auth?: Auth, options?: any): AxiosPromise<Auth>;

}

/**
 * LoginService - object-oriented interface
 * @export
 * @class LoginService
 * @extends {BaseAPI}
 */
export class LoginService extends BaseAPI implements LoginServiceInterface {
    /**
     * wechselt den User anhand des Payloads, Ausführung durch Admin, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
     * @summary Login change
     * @param {Auth} auth Authentifizierung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginService
     */
    public changelogin(auth: Auth, options?: any) {
        return LoginServiceFp(this.configuration).changelogin(auth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Überprüft anhand des Payloads ob Username / Password übereinstimmen, und liefert ein Access- und Refresh-Token um Autorisierte REST Aufrufe auszuführen.
     * @summary Login
     * @param {Auth} auth Authentifizierung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginService
     */
    public login(auth: Auth, options?: any) {
        return LoginServiceFp(this.configuration).login(auth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * meldet den Benutzer ab
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginService
     */
    public logout(options?: any) {
        return LoginServiceFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualisiert den Access Token mit einem gültigen Refresh Token
     * @summary Token Update
     * @param {Auth} [auth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginService
     */
    public refreshTokens(auth?: Auth, options?: any) {
        return LoginServiceFp(this.configuration).refreshTokens(auth, options).then((request) => request(this.axios, this.basePath));
    }
}
